$(document).ready(function () {
	// This code will run as soon as the DOM is ready

	setTimeout(() => {
		// $('.product-meal-plan-right.active-meal_form .delivery-button.selected-option').next().click()
		const weekCount = $(
			".product-meal-plan-right.active-meal_form .delivery-button.selected-option"
		).attr("data-weeks");
		$(".product-meal-plan-right.active-meal_form")
			.find("product-step-form form")
			.append(
				`<input type="hidden" name="properties[_week_count]" value="${weekCount}">`
			);
	}, 200);

	$(document).on("change", ".mealPreferenceInput", function () {
		const value = $(this).val();
		if (value && value == "half") {
			if (window.location.href.includes("quiz-product")) {
				const $variantSelectOpt = $(this).closest("variant-selects");
				const productText = $variantSelectOpt
					.find("script.productJson")
					.text();
				const productJson = JSON.parse(productText);
				const selectedOption = $variantSelectOpt
					.find(".delivery-button.selected-option")
					.attr("data-weeks");
				console.log("selectedOption", selectedOption);
				const weekCount = parseInt(selectedOption, 10) * 2;
				console.log("weekCount", weekCount);
				const sellingPlanId = getSellingPlanId(
					productJson.selling_plan_groups,
					weekCount
				);
				console.log("sellingPlanId", sellingPlanId);
				const productStepForm = $variantSelectOpt
					.parent()
					.find(".quiz-form");
				console.log("productStepForm", productStepForm);
				setTimeout(() => {
					const selectElement = productStepForm.find(
						'input[name="selling_plan"]'
					);
					selectElement.val(sellingPlanId).trigger("change");
					const $priceSection = productStepForm.find(".priceSummery");
					const applicablePriceString = $priceSection.attr(
						"data-applicable-price"
					);
					const actualPrice = parseFloat(
						$priceSection.attr("data-actual-price")
					).toFixed(2);
					const applicablePrice = parseFloat(
						applicablePriceString
					).toFixed(2);
					const halfPrice = (actualPrice / weekCount).toFixed(2);
					const discountedHalfPrice = parseFloat(
						(halfPrice * 80) / 100
					).toFixed(2);
					const html = `
                    <span style="font-weight: 600;text-decoration: line-through; color: #C2C2C2; font-size:24px">$${halfPrice}</span>
                    <span style="font-weight: bold; font-size: 24px;">$${discountedHalfPrice}<span style="font-size: 16px;">/week</span></span>
                    <span style="font-size: 18px;margin-left: 10px;">(20% first box discount)</span>`;
					$($priceSection).html(html);
					productStepForm
						.find(".shippedWeeksCount .weeks")
						.text(`${weekCount} weeks`);
					$(".col-right-section .newHalfOrder").addClass("active");
					productStepForm.append(
						`<input type="hidden" name="properties[_order_type]" value="half">`
					);
					productStepForm.append(
						`<input type="hidden" name="properties[_week_count]" value="${weekCount}">`
					);
				}, 200);
			} else {
				const $variantSelectOpt = $(this).closest(
					"variant-selects-opt"
				);
				const productText = $variantSelectOpt
					.find("script.productJson")
					.text();
				const productJson = JSON.parse(productText);
				const weekCount =
					parseInt(
						$variantSelectOpt
							.find(".delivery-button.selected-option")
							.attr("data-weeks"),
						10
					) * 2;
				const sellingPlanId = getSellingPlanId(
					productJson.selling_plan_groups,
					weekCount
				);
				const productStepForm = $variantSelectOpt
					.parent()
					.find("product-step-form");
				setTimeout(() => {
					const selectElement = productStepForm.find(
						'select[name="selling_plan"]'
					);
					if (
						selectElement.find(`option[value="${sellingPlanId}"]`)
							.length === 0
					) {
						selectElement.append(
							new Option(`Plan ${sellingPlanId}`, sellingPlanId)
						);
					}
					selectElement.val(sellingPlanId).trigger("change");
					const $priceSection = productStepForm.find(".priceSummery");
					const applicablePriceString = $priceSection.attr(
						"data-applicable-price"
					);
					const actualPrice = parseFloat(
						$priceSection.attr("data-actual-price")
					).toFixed(2);
					const applicablePrice = parseFloat(
						applicablePriceString
					).toFixed(2);
					const halfPrice = (actualPrice / weekCount).toFixed(2);
					const discountedHalfPrice = parseFloat(
						(halfPrice * 80) / 100
					).toFixed(2);
					const html = `
                     <span style="font-weight: 600;text-decoration: line-through; color: #C2C2C2; font-size:24px">$${halfPrice}</span>
                    <span style="font-weight: bold; font-size: 24px;">$${discountedHalfPrice}<span style="font-size: 16px;">/week</span></span>
                    <span style="font-size: 18px;margin-left: 10px;">(20% first box discount)</span>
                `;
					$($priceSection).html(html);
					productStepForm
						.find(".shippedWeeksCount .weeks")
						.text(`${weekCount} weeks`);
					$(".col-right-section .newHalfOrder").addClass("active");
					productStepForm
						.find("form")
						.append(
							`<input type="hidden" name="properties[_order_type]" value="half">`
						);
					productStepForm
						.find("form")
						.append(
							`<input type="hidden" name="properties[_week_count]" value="${weekCount}">`
						);
				}, 200);
			}
		} else {
			const $variantSelectOpt = $(this).closest("variant-selects-opt");
			const weekCount = parseInt(
				$variantSelectOpt
					.find(".delivery-button.selected-option")
					.attr("data-weeks"),
				10
			);
			$(".col-right-section .newHalfOrder").removeClass("active");
			const weekCountInput = $(
				'.product-meal-plan-right.active-meal_form input[name="properties[_week_count]"]'
			);
			if (weekCountInput.length) {
				weekCountInput.val(weekCount);
			} else {
				const $variantSelectOpt = $(this).closest(
					"variant-selects-opt"
				);
				const productStepForm = $variantSelectOpt
					.parent()
					.find("product-step-form form");
				productStepForm
					.find("form")
					.append(
						`<input type="hidden" name="properties[_week_count]" value="${weekCount}">`
					);
				weekCountInput.val(weekCount);
			}
			$('input[name="properties[_order_type]"]').remove();
			$('input[name="properties[_week_count]"]').remove();
		}
	});

	document.addEventListener("afterAddRemoveCustomDiet", function (e) {
		setTimeout(() => {
			const hasWeekCount = $(
				".product-meal-plan-right.active-meal_form"
			).find('input[name="properties[_week_count]"]');
			const weekCount = $(
				".product-meal-plan-right.active-meal_form .delivery-button.selected-option"
			).attr("data-weeks");
			if (hasWeekCount.length) {
				hasWeekCount.val(weekCount);
			} else {
				$(".product-meal-plan-right.active-meal_form")
					.find("product-step-form form")
					.append(
						`<input type="hidden" name="properties[_week_count]" value="${weekCount}">`
					);
			}
			const dogName = $(
				".product-meal-plan-right.active-meal_form input.dog-name"
			).val();
			$(".product-meal-plan-right.active-meal_form")
				.find(".toggle-container-half-order .dognamespan")
				.text(dogName);
		}, 200);
	});

	$(document).on(
		"click",
		".product-meal-plan-right.active-meal_form .delivery-button",
		function () {
			var $activeDiv = $(this).closest(".product-meal-plan-right");
			var weeks = $(this).data("weeks") || $(this).attr("data-weeks");
			// Get the checked mealPreferenceInput in the active form
			var $checkedPref = $activeDiv.find(
				"input.mealPreferenceInput:checked"
			);
			var prefValue = $checkedPref.val();
			// Loop through other meal plan divs
			$(".product-meal-plan-right")
				.not(".active-meal_form")
				.each(function () {
					var $otherDiv = $(this);
					// 1. Sync delivery button
					var $matchBtn = $otherDiv
						.find('.delivery-button[data-weeks="' + weeks + '"]')
						.first();
					if ($matchBtn.length) {
						$matchBtn.trigger("click");
					}
					// 2. Sync meal preference
					if (prefValue) {
						var $otherPref = $otherDiv.find(
							'input.mealPreferenceInput[value="' +
								prefValue +
								'"]'
						);
						if ($otherPref.length) {
							$otherPref.prop("checked", true).trigger("change");
						}
					}
				});
		}
	);
	// 2. Sync mealPreferenceInput changes separately
	$(document).on(
		"change",
		".product-meal-plan-right.active-meal_form input.mealPreferenceInput",
		function () {
			var prefValue = $(this).val();
			$(".product-meal-plan-right")
				.not(".active-meal_form")
				.each(function () {
					var $otherPref = $(this).find(
						'input.mealPreferenceInput[value="' + prefValue + '"]'
					);
					if ($otherPref.length) {
						$otherPref.prop("checked", true).trigger("change");
					}
				});
		}
	);

	$(document).on("click", ".plan-added", function () {
		setTimeout(function () {
			$(".other-custom-diets .newHalfOrder.active").removeClass("active");
		}, 300);
	});
	$(document).on("click", ".plan-needtoAdd", function () {
		setTimeout(function () {
			// find checked meal preference in the active form
			var prefVal = $(
				".product-meal-plan-right.active-meal_form .mealPreferenceInput:checked"
			).val();
			if (prefVal === "half") {
				$(".custom-selected-diet .newHalfOrder").addClass("active");
			}
		}, 300);
	});
	$(document).on(
		"change",
		".product-meal-plan-right.active-meal_form .consultation-opt-in",
		function () {
			const isChecked = $(this).is(":checked");

			$(".product-meal-plan-right").each(function () {
				const $otherCheck = $(this).find(".consultation-opt-in");
				if ($otherCheck.length) {
					$otherCheck.prop("checked", isChecked);

					// Also trigger the change to show/hide details
					if (isChecked) {
						$otherCheck
							.closest(".consultation-options")
							.find(".consultation-details")
							.show();
					} else {
						$otherCheck
							.closest(".consultation-options")
							.find(".consultation-details")
							.hide();
					}
				}
			});
		}
	);

	// Sync Consultation Method (Radio buttons) Across Forms
	$(document).on(
		"change",
		'.product-meal-plan-right.active-meal_form input[name^="attributes[contact-preference]"]',
		function () {
			const methodValue = $(this).val();
			const nameAttr = $(this).attr("name");

			$(".product-meal-plan-right").each(function () {
				// Find the corresponding radio button in other forms
				const $otherRadios = $(this).find(
					`input[name^="attributes[contact-preference]"]`
				);
				if ($otherRadios.length) {
					const $matchingRadio = $otherRadios.filter(
						`[value="${methodValue}"]`
					);
					if ($matchingRadio.length) {
						$matchingRadio.prop("checked", true);
						$('input[name="note"]').val(
							`customer contact preference: ${methodValue}`
						);
					}
				}
			});
		}
	);

	// Handle product switching - reset consultation options when forms change
	// $(document).on("click", ".plan-needtoAdd, .plan-added", function () {
	// 	setTimeout(() => {
	// 		// Reset consultation options in all non-active forms
	// 		$(".product-meal-plan-right")
	// 			.not(".active-meal_form")
	// 			.each(function () {
	// 				const $consultationOptIn = $(this).find(
	// 					".consultation-opt-in"
	// 				);
	// 				if ($consultationOptIn.length) {
	// 					$consultationOptIn.prop("checked", false);
	// 					$(this).find(".consultation-details").hide();
	// 				}
	// 			});
	// 	}, 300);
	// });

	// $(document).on('click', '.plan-needtoAdd, .plan-added', function() {
	//   setTimeout(() => {
	//     const $activeForm = $('.product-meal-plan-right.active-meal_form');
	//     if (!$activeForm.length) return;

	//     const isChecked = $activeForm.find('.consultation-opt-in').is(':checked');
	//     const methodValue = $activeForm.find('input[name^="attributes[contact-preference]"]:checked').val();

	//     $('.product-meal-plan-right').not('.active-meal_form').each(function() {
	//       const $consultCheck = $(this).find('.consultation-opt-in');
	//       $consultCheck.prop('checked', isChecked);

	//       if (isChecked) {
	//         $(this).find('.consultation-details').show();
	//         if (methodValue) {
	//           $(this).find(`input[name^="attributes[contact-preference]"][value="${methodValue}"]`)
	//             .prop('checked', true);
	//         }
	//       } else {
	//         $(this).find('.consultation-details').hide();
	//       }
	//     });
	//   }, 300);
	// });

	document.addEventListener("afterVariantChange", function (e) {
		const srcElement = $(e.detail.event.srcElement);
		console.warn("trigger");
		if (srcElement.is("select")) {
			const hasWeekCount = $(srcElement)
				.parents(".product-meal-plan-right.active-meal_form")
				.find('input[name="properties[_week_count]"]');
			const weekCount = $(
				".product-meal-plan-right.active-meal_form .delivery-button.selected-option"
			).attr("data-weeks");
			if (hasWeekCount.length) {
				hasWeekCount.val(weekCount);
			} else {
				$(".product-meal-plan-right.active-meal_form")
					.find("product-step-form form")
					.append(
						`<input type="hidden" name="properties[_week_count]" value="${weekCount}">`
					);
			}
		}

		if (srcElement.hasClass("dog-name")) {
			const dosName = srcElement.val();
			const $heading = $(srcElement)
				.parents(".variant-selects-opt")
				.find(".toggle-container-half-order h3");
			let heading = $heading.text();
			// Replace placeholder with actual dog name
			const dynamicHeading = heading.replace("Dog", `${dosName}'s`);
			$heading.text(dynamicHeading);
		}

		if (!srcElement.hasClass("mealPreferenceInput")) {
			const $variantSelectOpt = $(e.detail.event.target).parents(
				"variant-selects-opt"
			);
			$variantSelectOpt
				.find(".toggle-container-half-order .mealToggleInput")
				.eq(0)
				.prop("checked", true);
		}

		$(".col-right-section .newHalfOrder").removeClass("active");

		setTimeout(() => {
			const $variantSelectOpt = $(e.detail.event.target).parents(
				"variant-selects-opt"
			);
			if ($variantSelectOpt.find(".delivery-button").length == 1) {
				$variantSelectOpt
					.find(".delivery-button-option")
					.css("width", "50%");
				$variantSelectOpt
					.find(".delivery-button")
					.css("width", "100%")
					.click();
			} else {
				$variantSelectOpt
					.find(".delivery-button-option")
					.css("width", "100%");
				$variantSelectOpt.find(".delivery-button").css("width", "50%");
			}
		}, 200);
	});
});

const getSellingPlanId = (data, name) =>
	data
		.flatMap(({ selling_plans }) => selling_plans)
		.find(({ name: planName }) => planName.includes(name))?.id || null;
